// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".first-step-form-information{border:1px solid #949aba;border-radius:.5rem;display:flex;flex-direction:column;height:13rem;justify-content:space-between;padding:1rem}@media(max-width:1999.98px){.first-step-form-information{gap:1.5rem;height:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
